import { useState } from 'react'
import { supabase } from '../supabaseClient'

export default function Auth() {
  const [email, setEmail] = useState('')
  const [otp, setOtp] = useState('')
  const [step, setStep] = useState('email')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function sendOTP() {
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.signInWithOtp({ email })
    if (error) {
      setError(error.message)
    } else {
      setStep('otp')
    }
    setLoading(false)
  }

  async function verifyOTP() {
    setLoading(true)
    setError('')
    const { error } = await supabase.auth.verifyOtp({
      email,
      token: otp,
      type: 'magiclink'
    })
    if (error) {
      setError(error.message)
    }
    setLoading(false)
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0D0D0D',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      fontFamily: "'DM Sans', sans-serif"
    }}>

      {/* Logo */}
      <div style={{ marginBottom: 48, textAlign: 'center' }}>
        <div style={{
          fontSize: 48,
          fontWeight: 800,
          color: '#fff',
          letterSpacing: '-1px'
        }}>
          sauce<span style={{ color: '#FF5722' }}>.</span>
        </div>
        <div style={{ color: '#555', fontSize: 14, marginTop: 8 }}>
          find your plan for tonight
        </div>
      </div>

      {/* Card */}
      <div style={{
        background: '#141414',
        border: '1.5px solid #1f1f1f',
        borderRadius: 24,
        padding: 32,
        width: '100%',
        maxWidth: 380
      }}>

        {step === 'email' ? (
          <>
            <div style={{ color: '#fff', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
              What's your email?
            </div>
            <div style={{ color: '#555', fontSize: 13, marginBottom: 24 }}>
              We'll send you a one-time code
            </div>
            <input
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              style={{
                width: '100%',
                background: '#1a1a1a',
                border: '1.5px solid #2a2a2a',
                borderRadius: 12,
                color: '#fff',
                padding: '12px 16px',
                fontSize: 14,
                outline: 'none',
                fontFamily: "'DM Sans', sans-serif",
                marginBottom: 16,
                boxSizing: 'border-box'
              }}
            />
            {error && (
              <div style={{ color: '#ff4444', fontSize: 12, marginBottom: 12 }}>
                {error}
              </div>
            )}
            <button
              onClick={sendOTP}
              disabled={email.length < 5 || loading}
              style={{
                width: '100%',
                background: email.length >= 5 ? '#FF5722' : '#1a1a1a',
                color: email.length >= 5 ? '#fff' : '#444',
                border: 'none',
                borderRadius: 12,
                padding: '14px',
                fontSize: 15,
                fontWeight: 600,
                cursor: email.length >= 5 ? 'pointer' : 'not-allowed',
                fontFamily: "'DM Sans', sans-serif",
                transition: 'all 0.2s'
              }}
            >
              {loading ? 'Sending...' : 'Get the sauce →'}
            </button>
          </>
        ) : (
          <>
            <div style={{ color: '#fff', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
              Enter your code
            </div>
            <div style={{ color: '#555', fontSize: 13, marginBottom: 24 }}>
              Sent to {email}
            </div>
            <input
              type="tel"
              placeholder="000000"
              value={otp}
              onChange={e => setOtp(e.target.value)}
              maxLength={6}
              style={{
                width: '100%',
                background: '#1a1a1a',
                border: '1.5px solid #2a2a2a',
                borderRadius: 12,
                color: '#fff',
                padding: '12px 16px',
                fontSize: 20,
                letterSpacing: 8,
                textAlign: 'center',
                outline: 'none',
                fontFamily: "'DM Sans', sans-serif",
                marginBottom: 16,
                boxSizing: 'border-box'
              }}
            />
            {error && (
              <div style={{ color: '#ff4444', fontSize: 12, marginBottom: 12 }}>
                {error}
              </div>
            )}
            <button
              onClick={verifyOTP}
              disabled={otp.length !== 6 || loading}
              style={{
                width: '100%',
                background: otp.length === 6 ? '#FF5722' : '#1a1a1a',
                color: otp.length === 6 ? '#fff' : '#444',
                border: 'none',
                borderRadius: 12,
                padding: '14px',
                fontSize: 15,
                fontWeight: 600,
                cursor: otp.length === 6 ? 'pointer' : 'not-allowed',
                fontFamily: "'DM Sans', sans-serif",
                transition: 'all 0.2s'
              }}
            >
              {loading ? 'Verifying...' : "Let's go 🔥"}
            </button>
            <div
              onClick={() => setStep('email')}
              style={{
                color: '#555',
                fontSize: 12,
                textAlign: 'center',
                marginTop: 16,
                cursor: 'pointer'
              }}
            >
              Wrong email? Go back
            </div>
          </>
        )}
      </div>

      <div style={{ color: '#333', fontSize: 11, marginTop: 24, textAlign: 'center' }}>
        By continuing you agree to Sauce's terms. <br />No spam. Ever.
      </div>

    </div>
  )
}